import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  IMappers,
  INearbyHousesExplanationRequest,
} from '../../../repositories/valuation-offer-history/v2/nearby-houses-explanation';
import { TAboutNearbyHousesData } from '../../../types/offerHistory';

export const createAboutNearbyHousesMapper = (
  parameters: INearbyHousesExplanationRequest,
): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response,
  400: ({ message }) =>
    new HttpBadStatusCodeError({
      statusCode: 400,
      message: message || /* istanbul ignore next */ '',
      domain: 'aboutNearbyHousesService',
      details: { ...parameters },
    }),
});

export type TMappedResponse200 = TAboutNearbyHousesData;
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TMappedResponse = TMappedResponse200 | TMappedResponse400;
